import {useDispatch} from 'react-redux';
import useLogin from '../../../common/hook/useLogin';
import useTypedSelector from '../../../common/hook/useTypedSelector';
import {useFetchInfo} from '../../../common/util/fetch';
import {getLocalRecentItemsV4} from '../../../commonSub/function';
import {actions} from '../state/action';
import {IMyPageSecondTab} from '../type';

export default function useMyPageTabInfo({
  tab,
  actionType,
  isEdit,
}: {
  tab: IMyPageSecondTab;
  actionType: string;
  isEdit?: boolean;
}) {
  const [recent, like, purchase, originEditPurchase] = useTypedSelector(
    state => {
      const tabState = isEdit ? state.myPage.editTab : state.myPage.tab;
      return [
        tabState.recent,
        tabState.like,
        tabState.own,
        state.myPage.originEditOwn,
      ];
    }
  );
  const {isLogin, isLoginChecking} = useLogin();
  const {isFirstFetched} = useFetchInfo(actionType, tab);

  const contents =
    recent?.contents || like?.contents || purchase?.contents || [];
  const isEmpty = contents.length === 0;

  const isRecentTab = tab === 'recent';
  const isLikeTab = tab === 'like';
  const isPurchaseTab = tab === 'own';

  const showOnlyLocalList = !isLoginChecking && !isLogin && isRecentTab;
  const isFirstLoading = isLoginChecking || (isLogin && !isFirstFetched);

  const dispatch = useDispatch();
  const setOnlyLocalList = (isEdit?: boolean) => {
    dispatch(
      actions.setPropertyValues(isEdit ? 'editTab' : 'tab', {
        recent: {
          contents: getLocalRecentItemsV4(),
        },
      })
    );
  };

  return {
    isRecentTab,
    isLikeTab,
    isPurchaseTab,
    isEmpty,
    isFirstLoading,
    isLogin,
    isLoginChecking,
    showOnlyLocalList,
    recent,
    like,
    purchase,
    originEditPurchase,
    setOnlyLocalList,
  };
}
